import {
  CLEAR_PRODUCTION,
  FETCH_PRODUCTION_OVERVIEW_SUCCESS,
  FETCH_PRODUCTION_VACANCIES_SUCCESS,
  FETCH_PRODUCTION_VOICE_TESTS_SUCCESS
} from '../../../actions/pages/production-page'

export function productionPage(
  state = {
    overview: null,
    vacancies: null,
    voiceTests: null
  },
  action
) {
  switch (action.type) {
    case CLEAR_PRODUCTION: {
      return Object.assign({}, state, {
        overview: null,
        vacancies: null,
        voiceTests: null
      })
    }
    case FETCH_PRODUCTION_OVERVIEW_SUCCESS: {
      return Object.assign({}, state, {
        overview: action.overview
      })
    }
    case FETCH_PRODUCTION_VACANCIES_SUCCESS: {
      return Object.assign({}, state, {
        vacancies: action.vacancies
      })
    }
    case FETCH_PRODUCTION_VOICE_TESTS_SUCCESS: {
      return Object.assign({}, state, {
        voiceTests: action.voiceTests
      })
    }
    default:
      return state
  }
}
